// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19FQN","colBig":"styles_colBig__y_N1B","colSmall":"styles_colSmall__1-5_f","shopifyNameWrapper":"styles_shopifyNameWrapper__2fRGl"};